export enum ActionType {
    RECORD_START = '_DEBUG__RECORD_START',
    RECORD_STOP = '_DEBUG__RECORD_STOP',
    RECORD_SERVE = '_DEBUG__RECORD_SERVE',
    RECORD_CLEAR = '_DEBUG__RECORD_CLEAR',
}
